import { create } from 'zustand';

// Safe storage wrapper — falls back to sessionStorage if localStorage blocked (iOS Safari private mode)
const storage = {
  get: (key) => {
    try { return localStorage.getItem(key); }
    catch {
      try { return sessionStorage.getItem(key); }
      catch { return null; }
    }
  },
  set: (key, val) => {
    try { localStorage.setItem(key, val); }
    catch {
      try { sessionStorage.setItem(key, val); }
      catch {}
    }
  },
  remove: (key) => {
    try { localStorage.removeItem(key); }
    catch {
      try { sessionStorage.removeItem(key); }
      catch {}
    }
  },
};

// Export so api.js can use same storage
export { storage };

export const useAuthStore = create((set) => ({
  user: null,
  token: storage.get('token'),

  setAuth: (user, token) => {
    storage.set('token', token);
    set({ user, token });
  },

  logout: () => {
    storage.remove('token');
    set({ user: null, token: null });
  },
}));
